import React from 'react';
import parse from 'html-react-parser';
import { marked } from 'marked';

import './styles.scss';

interface MarkdownDisplayProps {
  markdownText: string;
}

function isAbsoluteURL(url: any) {
  return /^(https?|http):\/\//i.test(url);
}

const MarkdownDisplay: React.FC<MarkdownDisplayProps> = ({ markdownText }) => {
  if (!markdownText) {
    return null;
  }

  const renderer = new marked.Renderer();
  renderer.link = (href, title, text) => {
    if (!isAbsoluteURL(href)) {
      href = `https://${href}`;
    }

    const target = '_blank';
    return `<a href="${href}" target="${target}" rel="noopener noreferrer">${text}</a>`;
  };

  const markedOptions = {
    renderer,
  };

  const html = marked(markdownText, markedOptions);
  return <div className="markdown">{parse(html)}</div>;
};
export default MarkdownDisplay;
